module.exports = __webpack_public_path__ + "static/media/Colette Queen Bed Base - 155x205 cm_Dark Blue.83b51cc5.png";